import { QuestsType } from "../../../../models/notifications";
import { GetInboxQuestsQuery } from "./types/queries.generated";
import { InboxQuest, TaskStatus, QuestCompletionStatus, AgreementUserRole } from "../../../../models/generated/graphql";

export type InboxQuestContentPayload = {
	caseId: string;
	value: number;
	threshold?: number;
	currency: string;
	patientId: string;
	brandName: string;
	therapyDecision: string;
};

export interface InboxQuestProps {
	questId: string;
	questDate: number;
	triggerEventId: QuestsType;
	isAutoCompleted: boolean;
	questStatus: TaskStatus;
	isAssignee: boolean;
	questCompletionStatus?: QuestCompletionStatus;
	questContentEn: string;
	questContentDe: string;
	userRole: AgreementUserRole;
	content: InboxQuestContentPayload;
	index: number;
	questOwner: any;
	resolvedBy: any;
}

export interface InboxQuestComponentProps extends InboxQuestProps {
	isVisible: boolean;
	rowIndex: number;
	setItemSize: (index: number, size: number) => void;
	onUpdate: (index: number, updatedQuest: any) => void;
}

const mapContent = (quest: InboxQuest, t: (key: string, options?: any) => any) => {
	return <InboxQuestContentPayload>{
		caseId: quest.caseInfo?.caseId || 0,
		value: quest.value,
		threshold: quest.threshold,
		currency: quest.caseInfo?.currency,
		patientId: quest.caseInfo?.patientId,
		brandName: quest.brandName,
		therapyDecision: t(`decisions-${quest.caseInfo?.therapyDecision}`),
	};
}

export const mapInboxQuests = (
	data: GetInboxQuestsQuery,
	t: (key: string, options?: any) => any
): Array<InboxQuestProps> => {
	if (!data?.GetInboxQuests) return [];
	return data.GetInboxQuests.map((quest: InboxQuest, i: number) => ({
		triggerEventId: quest.triggerEventId,
		questDate: quest.timeStamp,
		questStatus: quest.questStatus,
		questCompletionStatus: quest.completionStatus,
		content: mapContent(quest, t),
		userRole: quest.caseInfo?.userRole ?? AgreementUserRole.LimitedAccessUser,
		questContentEn: quest.questContentEn ?? "",
		questContentDe: quest.questContentDe ?? "",
		index: i,
		questId: quest.id,
		questOwner: quest.owner,
		resolvedBy: quest.resolvedBy,
		isAssignee: quest.caseInfo?.isAssignee ?? false,
		isAutoCompleted: quest.isAutoCompleted,
	}));
};
